export default [
  'uuid',
  'uid',
  'id',
  'created_at',
  'updated_at',
]
